module.exports = "\r\n<div class=\"divInfo\">\r\n    <h4>Informnación</h4>\r\n    - Acceso de por vida a todas las secciones <br>\r\n    - Acceso a nuevas secciones sin coste adicional <br>\r\n    - Descargar proyecto completo <br>\r\n    - Soporte para dudas o errores <br> <br>\r\n\r\n    Precio 30$ (Unos 26€)\r\n</div>\r\n<button (click)=\"openCheckout()\" type=\"button\" class=\"btn btn-info\">Pagar</button>"


//////////////////
// WEBPACK FOOTER
// ./src/app/payment/payment.component.html
// module id = ./src/app/payment/payment.component.html
// module chunks = main